import { render, staticRenderFns } from "./ReportOrdenes.vue?vue&type=template&id=e608f816"
import script from "./ReportOrdenes.vue?vue&type=script&lang=js"
export * from "./ReportOrdenes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports